import React, {useState} from 'react';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

export default function InventoryDocumentInvoices({document}) {
  const {t} = useTranslation('common');
  const [visible, setVisible] = useState(false);
  // Missing means not authorized / not supplied, not necessarily no invoice.
  if (!Array.isArray(document.linked_invoices)) return <span>—</span>;
  const invoices = document.linked_invoices;
  if (!invoices.length) return <span>{t('deliveryNoInvoice')}</span>;
  return <>
    <Button type="button" className="p-button-text p-button-sm" icon="pi pi-file"
      label={t('deliveryInvoiceCount', {count: invoices.length})} onClick={() => setVisible(true)}/>
    <Dialog header={document.document_number + ' • ' + t('deliveryLinkedInvoices')} visible={visible}
      onHide={() => setVisible(false)} style={{width: '32rem', maxWidth: '95vw'}}>
      {invoices.map(invoice => <div key={invoice.id} className="p-d-flex p-ai-center p-jc-between p-py-2" style={{gap: '1rem', borderBottom: '1px solid var(--surface-border)'}}>
        <span style={{overflowWrap: 'anywhere'}}>
          <strong>{invoice.receipt_number || t('deliveryInvoiceDraft')}</strong>
          {invoice.is_draft && invoice.receipt_number && <small className="p-ml-2">{t('deliveryInvoiceDraft')}</small>}
          {invoice.is_storno && <small className="p-ml-2">{t('deliveryInvoiceStorno')}</small>}
        </span>
        <Link className="p-button p-button-text p-button-sm" to={'/finance/receipt/read/' + invoice.id}>
          <i className="pi pi-eye p-mr-2"/>{t('receiptView')}
        </Link>
      </div>)}
    </Dialog>
  </>;
}
